
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Classical Conclave </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm devaki-pandit section-banner-bg-1">
    <div class="container">

        <div class="row">
            <div class="col-lg-8">
                <div class=" text-justify">
                    <h2 class="head-lea">PTA. DEVAKI PANDIT <span class="small-sm">27<sup>th</sup> April 2015 </span>
                    </h2>
                </div>
                <p>
                    Pta. Devaki Pandit, born in a family of dedicated musicians and connoisseurs of music, imbibed the
                    Sanskaras, values of Indian classical music traditions from a very young age. She is one of the
                    finest artistes of Classical Vocal music, which she has pursued since childhood.
                    Devaki Pandit was the disciple of the esteemed and creative genius Gurus like Pt. Jitendra Abhisheki
                    and Gaan Saraswati Kishoritai Amonkar, from whom she has imbibed the intricacies of classical music.

                </p>

                <p>
                    As a novice, she trained under Pt Vasantrao Kulkarni and later on from musicologist Pt. Babanrao
                    Haldankar of Agra gharana and Dr. Arun Dravid of Jaipur Atrauli gharana.
                </p>


                <p>
                    She has explored music through various forms like thumri, bhajans, ghazals, film music and fusion
                    music. She is a versatile and popular performer, having lent her voice to many films and television
                    serials.
                </p>


            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/devaki-pandit.webp"
                        alt="GHRSCF">
                </div>
            </div>
            <div class="col-md-12">
                <p>
                    Devaki Pandit has received many awards, including the best playback singer award from the
                    Maharashtra Government and the Zee Gaurav Puraskar for five consecutive years. She is also the
                    recipient of the Young Maestro Award from IMA, which she received at the hands of former President
                    Dr. APJ Abdul Kalam and the Aditya Birla Kala Kiran Puraskar. She has also composed the music for
                    many devotional albums and found her own musical expressions through her compositions. Her album
                    ‘Ganadheesh’ received critical acclaim and also the best composer award from BigStar Music Awards.
                </p>
            </div>

        </div>
        <div class="border-line-sm"></div>
        <div class="row flex-row-reverse" id="prasad-khaparde">
            <div class="col-lg-8">
                <div class=" text-justify">
                    <h2 class="head-lea">PT. PRASAD KHAPARDE <span class="small-sm">27<sup>th</sup> April 2015 </span>
                    </h2>
                </div>
                <p>
                    Pt. Prasad Khaparde is a professional Hindustani classical vocalist and a most senior disciple of
                    Ustad Rashid khan of Rampur sahaswan gharana. He was a past scholar of reputed (SRA) sangeet
                    research academy of kolkata. He gave Individual performances in all prestigious organization and
                    festivals of india like Sawai gandharva pune, shri baba harivallbh jalandhar, Taansen sangeet
                    mahotsav etc. Had a successful tours of abroad. Other performances include MTV coke studio and
                    fusions with different country s music. A grade artist of all India Radio. Empanelled artist of ICCR
                    Delhi.
                </p>


            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/prasad-khaparde.webp"
                        alt="GHRSCF">
                </div>
            </div>


        </div>
        <div class="border-line-sm"></div>
        <div class="row row-cols-1 row-cols-md-3">
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Media Coverage</h4>
                        </div>
                    </div>
                </div>
                <iframe
                    src="https://e.issuu.com/anonymous-embed.html?u=raisonigroupofinstitutions&d=culturalevent_22c0c508ce553c"
                    width="100%" height="230" frameborder="0" allowfullscreen="true"></iframe>

            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Videos</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                    <div class="col-md-6">
                        <iframe width="100%" height="230" src="https://www.youtube.com/embed/dSby_1miUuY?start=18"
                            frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                    </div>
                    <div class="col-md-6">
                        <iframe width="100%" height="230" src="https://www.youtube.com/embed/epVY4t6DPO0?start=6"
                            frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                    </div>
                </div>


            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Photos</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="photogallery#deviki-pandit" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dp1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dp1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dp1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dp2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dp2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dp2.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dp3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dp3.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dp3.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dp4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dp4.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dp4.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dp5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dp5.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dp5.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dp6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dp6.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dp6.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>

            </div>



        </div>
    </div>

</section>
